import { NzModalService } from 'ng-zorro-antd/modal';
import { HttpClient } from "@angular/common/http";
import { Observable, ReplaySubject } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { HierarchyDto } from "./dto";
import { NzFormatEmitEvent } from 'ng-zorro-antd/tree';

@Injectable({
	providedIn: 'root'
})
export class HierarchyService extends AbstractHttpService {
	private cachedHierarchy?: HierarchyDto;
	private _hierarchy?: HierarchyDto;
	public hierarchy$ = new ReplaySubject<HierarchyDto>(1);

	constructor(httpClient: HttpClient, private _authService: AuthService, private modalService: NzModalService) {
		super(httpClient, '/api/gui/hierarchy', _authService);
		super.doGet(true, `/`).subscribe(result => {
			this.cachedHierarchy = result as HierarchyDto;

			let persistedHierarchy = sessionStorage.getItem('hierarchy');
			if (persistedHierarchy) {
				this._hierarchy = JSON.parse(persistedHierarchy);
			} else {
				this._hierarchy = this.cachedHierarchy;
			}
			_authService.setHierarchy(this._hierarchy!);
			this.hierarchy$.next(this._hierarchy!);
		});
	}
	public get fullHierarchy(): HierarchyDto | undefined {
		return this.cachedHierarchy;
	}
	public get hierarchy(): HierarchyDto | undefined {
		return this._hierarchy;
	}
	public set hierarchy(input: HierarchyDto) {
		this._hierarchy = input;
		sessionStorage.setItem('hierarchy', JSON.stringify(input));
		this._authService.setHierarchy(input!);
		this.hierarchy$.next(input!);
	}
	public setHierarchyById(id: number) {
		const hierarchy = this.findHierarchyById(id, this.cachedHierarchy!);
		this.hierarchy = hierarchy ?? this.cachedHierarchy!;
	}
	findHierarchyById(id: number, input: HierarchyDto): HierarchyDto | undefined {
		if (!id) {
			return this._hierarchy;
		}
		if (input.id == id) {
			return input;
		}
		for (let item of input.subHierarchies) {
			const out = this.findHierarchyById(id, item);
			if (out) {
				return out;
			}
		}
		return undefined;
	}
	findHierarchyAndParents(id: number): HierarchyDto[] {
		const path: HierarchyDto[] = [];
		const dfs = (node: HierarchyDto): boolean => {
			if (node.id === id) {
				path.push(node);
				return true;
			}
			for (const child of node.subHierarchies ?? []) {
				if (dfs(child)) {
					path.push(node);
					return true;
				}
			}
			return false;
		};

		dfs(this.cachedHierarchy!);
		return path;
	}
}

